import { render } from "./BlueCartIndicator.vue?vue&type=template&id=1c1820f9&scoped=true&ts=true"
import script from "./BlueCartIndicator.vue?vue&type=script&lang=ts"
export * from "./BlueCartIndicator.vue?vue&type=script&lang=ts"

import "./BlueCartIndicator.vue?vue&type=style&index=0&id=1c1820f9&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c1820f9"]])

export default __exports__